import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { firebaseAuth, pythonApiIp, logComponentLoad, serverIp } from '../../../../config/constants.js'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios'
import { Button, } from 'semantic-ui-react';
import ClosePayNowProjects from '../LargeProjects/ClosePayNowProjects'

class IvanDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            algoliaUser: ''
        }
    }

    componentDidMount() {


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }


    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "IvanDashboard");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    fillFacebookReach = () => {
        console.log("++++++++:sendDeduction");
        console.log("new state item array:");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'fillFacebookReach', {
            apiKey: "ad#4fsdUUddf",
            amountDep: this.state.deductAmount
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false });

                    alert("deduction sent.");
                    this.setState({
                        deductAmount: '',
                        deductReason: '',
                    })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    addFacebookCosts = () => {
        console.log("++++++++:sendDeduction");
        console.log("new state item array:");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'addFacebookCosts', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false });

                    alert("deduction sent.");
                    this.setState({
                        deductAmount: '',
                        deductReason: '',
                    })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log(error);
                //this.setState({ loading: false })
            });

    }

    runFbImagesWorkflow = () => {
        console.log("++++++++:sendDeduction");
        console.log("new state item array:");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'runFbImagesWorkflow', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false });

                    alert("runFbImagesWorkflow sent.");


                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    export_sales_charge_google_sheets = () => {
        console.log("++++++++:export_sales_charge_google_sheets");
        console.log("new state item array:");

        this.setState({ loading: true })

        axios.post(serverIp + 'td_workflow/export_sales_charge_google_sheets', {
            apiKey: "export_sales_charge_google_sheets",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false });

                    alert("export_sales_charge_google_sheets sent.");


                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    render() {

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        const uploadDocument = this.state.user && this.state.user.email && this.state.user.email == 'ivanmworozi@gmail.com'
            ? <h1>Upload Document - <Link to={'/dashboard/addDocument'}>Add Document (ivan only)</Link></h1>
            : 'no email'

        const closePayNowUI = this.state.user && this.state.user.email
            ? <ClosePayNowProjects user={this.state.user} />
            : ''

            

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("IvanDashboard")
            ? <div>

                <h1>enterAworiLog - <Link to={'/dashboard/enterAworiLog'}>enterAworiLog</Link></h1>
                <h1>Daily Expenses Ivan - <Link to={'/dashboard/dailyExpenses_ivan'}>dailyExpenses_ivan</Link></h1>
                <h1>Daily Expenses Ivan - <Link to={'/dashboard/dailyExpenses'}>dailyExpenses REGULAR</Link></h1>
                <h1>paymentsPage - <Link to={'/dashboard/paymentsPage'}>paymentsPage</Link></h1>
                <h1>Search Receipt - <Link to={'/dashboard/searchReceiptNumber'}>Search For Receipt</Link></h1>
                <h1>ViewCurrentSales - <Link to={'/dashboard/ViewCurrentSales'}>ViewCurrentSales</Link></h1>
                <h1>viewLargeProjectDocuments - <Link to={'/dashboard/viewLargeProjectDocuments'}>viewLargeProjectDocuments</Link></h1>
                <h1>addDocument - <Link to={'/dashboard/addDocument'}>addDocument</Link></h1>
                <h1>payroll - <Link to={'/dashboard/payroll'}>payroll</Link></h1>
                <h1>Monthly Expenses - <Link to={'/dashboard/monthlyExpenses'}>monthly Expenses</Link></h1>
                <h1>Stock Payment - <Link to={'/dashboard/stockPayment'}>Stock Item Payment (Send payment of Stock item to Beyonic)</Link></h1>
                <h1>Upload Daily Expense - <Link to={'/dashboard/dailyExpenses'}>Upload Daily Expense Single items</Link></h1>
                <h1>Upload Expense List - <Link to={'/dashboard/expensesUpload'}>Upload Daily Expense File</Link></h1>
                <h1>Pay Printing Charge - <Link to={'/dashboard/payPrintingCharges'}>Pay Printing Charges</Link></h1>
                <h1>Supplies List - <Link to={'/suppliesList'}>Supplies List</Link></h1>

                <h1>Search Receipt - <Link to={'/dashboard/enterReciept'}>enterReciept</Link></h1>
                <h1>Receipt List - <Link to={'/dashboard/receipList'}>View List of Receipts Entered</Link></h1>
                <h1>Search Receipt - <Link to={'/dashboard/searchReceiptNumber'}>Search For Receipt</Link></h1>
                <h1>Search orders in searchnow by date <Link to={'/dashboard/queryOrdersAlgolia'}>queryOrdersAlgolia</Link></h1>

                <h1>Add remove sales person from lead list - <Link to={'/dashboard/removeSalesPersonLeadList'}>removeSalesPersonLeadList</Link></h1>

                <h1>PayAllowances - <Link to={'/dashboard/payAllowances'}>payAllowances</Link></h1>
                <h1>PayAllowances - <Link to={'/dashboard/enterUnknowDeposit'}>enterUnknowDeposit</Link></h1>

                <Button onClick={this.fillFacebookReach}>fillFacebookReach</Button>
                <br/>
                <Button onClick={this.runFbImagesWorkflow}>runFbImagesWorkflow</Button>
                <br/>
                <Button onClick={this.export_sales_charge_google_sheets}>export_sales_charge_google_sheets</Button>
                <br/>
                <Button onClick={this.addFacebookCosts}>addFacebookCosts</Button>



                {uploadDocument}

                <br />
                {closePayNowUI}


            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>

            {wholeUI}

        </div>);
    }
}

export default IvanDashboard;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/IvanDashboard.js